// Rely on js-cookies
export const getCsrf = () => Cookies.get("csrftoken");

export const csrfHeader = () => new Headers({ "X-CSRFToken": getCsrf() });
